export default __webpack_public_path__ + "static/media/4.e03abf7f.jpg";